// upload 节点文件大小限制（对齐 V1 RichTextEditor/nodes/upload/limits.ts）。
// V1 行为：所有 upload 文件（不分图片/非图片）限 10MB，超限文件被过滤，
// 错误提示 1 秒内去重（批量或连续选超大文件时只提示一次，避免刷屏）。

export const MAX_UPLOAD_BYTES = 10 * 1024 * 1024;

export const isUploadFileTooLarge = (file: File): boolean =>
  file.size > MAX_UPLOAD_BYTES;

export const UPLOAD_FILE_SIZE_ERROR = '文件大小不能超过 10MB';

const DEDUPE_MS = 1000;
let lastNotifyAt = 0;

/** 是否应当发出"文件超 10MB"提示：距上次提示满 1 秒才返回 true（并记录本次时间）。 */
export const shouldNotifyUploadSizeError = (now: number = Date.now()): boolean => {
  if (now - lastNotifyAt < DEDUPE_MS) return false;
  lastNotifyAt = now;
  return true;
};

/** 测试用：重置去重时间戳，避免用例间相互污染。 */
export const resetUploadSizeErrorDedupeForTest = (): void => {
  lastNotifyAt = 0;
};
